export const genericMerchantLogos = [
  'https://iccdn.in/img/merchant-desktop-amazon.jpg',
  'https://iccdn.in/img/merchant-desktop-flipkart.jpg',
  'https://iccdn.in/img/merchant-desktop-tata-cliq.jpg',
  'https://iccdn.in/img/merchant-vijaysales.jpg',
  'https://iccdn.in/img/merchant-sangeetha-mobiles.jpg',
  'https://iccdn.in/img/merchant-desktop-myntra.jpg',
  'https://iccdn.in/img/merchant-decathlon.jpg',
  'https://iccdn.in/img/merchant_cult.fit_v2.png',
  'https://iccdn.in/img/merchant-sastiticket.jpg',
  'https://iccdn.in/img/merchant-happyeasygo-sale.jpg',
  'https://iccdn.in/img/merchant-mmt.jpg',
  'https://iccdn.in/img/merchant-desktop-via.jpg',
];

const mobileMerchantLogos = [
  'https://iccdn.in/img/merchant-desktop-amazon.jpg',
  'https://iccdn.in/img/merchant-desktop-flipkart.jpg',
  'https://iccdn.in/img/merchant-zebrs-v3.jpg',
  'https://iccdn.in/img/merchant-lotmobiles.jpg',
  'https://iccdn.in/img/merchant-bigc.jpg',
  'https://iccdn.in/img/merchant-desktop-tata-cliq.jpg',
  'https://iccdn.in/img/merchant-vijaysales.jpg',
  'https://iccdn.in/img/merchant-emibaba.jpg',
  'https://iccdn.in/img/merchant-qrs.jpg',
  'https://iccdn.in/img/merchant-sangeetha-mobiles.jpg',
];

const electronicsMerchantLogos = [
  'https://iccdn.in/img/merchant-desktop-flipkart.jpg',
  'https://iccdn.in/img/merchant-desktop-amazon.jpg',
  'https://iccdn.in/img/merchant-mdcomputers.jpg',
  'https://iccdn.in/img/merchant-zebrs-v3.jpg',
  'https://iccdn.in/img/merchant-vijaysales.jpg',
  'https://iccdn.in/img/merchant-primeabgb-logo.jpg',
  'https://iccdn.in/img/merchant-desktop-tata-cliq.jpg',
  'https://iccdn.in/img/merchant-emibaba.jpg',
  'https://iccdn.in/img/merchant-bajajelectricals.jpg',
  'https://iccdn.in/img/merchant-morphyrichards.jpg',
];

const furnitureMerchantLogos = [
  'https://iccdn.in/img/merchant_nilkamallogo.jpg',
  'https://iccdn.in/img/merchant-desktop-pepperfry.jpg',
  'https://iccdn.in/img/merchant-royaloak.jpg',
  'https://iccdn.in/img/merchant-urbanladder.jpg',
  'https://iccdn.in/img/merchant-desktop-amazon.jpg',
  'https://iccdn.in/img/merchant-desktop-flipkart.jpg',
  'https://iccdn.in/img/merchant-springtek.jpg',
  'https://iccdn.in/img/merchant-sleepyhead.jpg',
  'https://iccdn.in/img/merchant-mohh-logo.jpg',
  'https://iccdn.in/img/merchant-ikea.jpg',
];

const coolersMerchantLogos = [
  'https://iccdn.in/img/merchant-desktop-flipkart.jpg',
  'https://iccdn.in/img/merchant-desktop-amazon.jpg',
  'https://iccdn.in/img/merchant-vijaysales.jpg',
  'https://iccdn.in/img/merchant-desktop-tata-cliq.jpg',
  'https://iccdn.in/img/merchant-digi1electronics.jpg',
  'https://iccdn.in/img/merchant-bajajelectricals.jpg',
];

export const categoriesInfo = (variation) => {
  switch (variation && variation.toLowerCase()) {
    case 'me':
      return {
        variation: 'Mobiles',
        banner: 'https://iccdn.in/campaigns/page/mobile-category.png',
        merchantLogos: mobileMerchantLogos,
      };
    case 'hf':
      return {
        variation: 'Home & Furniture',
        banner: 'https://iccdn.in/campaigns/page/furniture-category.png',
        merchantLogos: furnitureMerchantLogos,
      };
    case 'ec':
      return {
        variation: 'Electronics',
        banner: 'https://iccdn.in/campaigns/page/electronics-category.png',
        merchantLogos: electronicsMerchantLogos,
      };
    case 'cr':
      return {
        variation: 'Coolers',
        banner: 'https://iccdn.in/campaigns/page/coolers-category.png',
        merchantLogos: coolersMerchantLogos,
      };

    default:
      return {
        variation: false,
        banner: false,
        merchantLogos: genericMerchantLogos,
      };
  }
};



// WEBPACK FOOTER //
// ./routes/campaign-activation/constants/index.js